import { LyMainProductFormBase } from "./base"
import { renderLyPopoverV4, renderIndicatorItems, renderLyCtrlButtons } from "@/utils/renders"

if (!customElements.get('ly-main-product-form-accessory-picker')) {
  customElements.define('ly-main-product-form-accessory-picker', class extends LyMainProductFormBase {

    #accessoryItemToInput = new WeakMap()
    #pickerToAccessoryItem = new WeakMap()
    #quantityToAccessoryItem = new WeakMap()
    pickerCheckboxs = []
    quantityInputs = []
    showroomAccessoryItems = []

    #freeMap = {}

    jsRenderWrapper = null

    connectedCallback() {
      super.connectedCallback()

      this.jsRenderWrapper = this.querySelector('.js-render-wrapper')

      this.init()

      requestAnimationFrame(this.handleShowroom)
    }

    disconnectedCallback() {
      this.removeEvents()

      super.disconnectedCallback()
    }

    init = () => {
      this.#accessoryItemToInput = new WeakMap()
      this.#pickerToAccessoryItem = new WeakMap()
      this.#quantityToAccessoryItem = new WeakMap()
      this.pickerCheckboxs = []
      this.quantityInputs = []
      this.showroomAccessoryItems = []

      this.#freeMap = {}

      this.accessoryItems = [...this.querySelectorAll('.ly-main-product-form-accessory-picker-item[data-id]')]
      this.accessoryItems.forEach(accessoryItem => {
        const pickerCheckbox = accessoryItem.querySelector('.ly-main-product-form-accessory-picker-item-picker-checkbox')
        const quantityInput = accessoryItem.querySelector('.ly-main-product-form-accessory-picker-item-quantity-input')

        this.#accessoryItemToInput.set(accessoryItem, { pickerCheckbox, quantityInput })
        this.#pickerToAccessoryItem.set(pickerCheckbox, accessoryItem)
        this.#quantityToAccessoryItem.set(quantityInput, accessoryItem)
        this.pickerCheckboxs.push(pickerCheckbox)
        this.quantityInputs.push(quantityInput)

        if (accessoryItem.hasAttribute('data-showroom-selected')) {
          this.showroomAccessoryItems.push(accessoryItem)
        }
      })
      this.moreInput = this.querySelector('.ly-main-product-form-accessory-picker-list-more-trigger-input')

      this.bindEvents()

      this.handleMoreChange()
      requestAnimationFrame(this.handleFreeAccessory)
    }

    bindEvents = () => {
      this.pickerCheckboxs.forEach(pickerCheckbox => {
        pickerCheckbox.addEventListener('change', this.handlePickerChange)
      })

      this.quantityInputs.forEach(quantityInput => {
        quantityInput.addEventListener('change', this.handleQuantityChange)
      })

      this.moreInput?.addEventListener('change', this.handleMoreChange)
    }

    removeEvents = () => {
      this.pickerCheckboxs.forEach(pickerCheckbox => {
        pickerCheckbox.removeEventListener('change', this.handlePickerChange)
      })

      this.quantityInputs.forEach(quantityInput => {
        quantityInput.removeEventListener('change', this.handleQuantityChange)
      })

      this.moreInput?.removeEventListener('change', this.handleMoreChange)
    }

    handlePickerChange = evt => {
      const { target } = evt
      const { checked } = target

      const accerroryItem = this.#pickerToAccessoryItem.get(target)
      accerroryItem.classList.toggle('is-checked', checked)

      const { id } = accerroryItem.dataset
      const freeCount = this.#freeMap[id] || 0
      let quantity = freeCount

      if (checked) {
        quantity += 1
      }

      window.publish('bus:accessory_picker_changed', { id, checked, quantity })
      // 取消选中，恢复数量选择器的默认值
      if (!checked) {
        const { quantityInput } = this.#accessoryItemToInput.get(accerroryItem)
        quantityInput.value = 1
      }
    }

    handleQuantityChange = evt => {
      const { target } = evt
      const accerroryItem = this.#quantityToAccessoryItem.get(target)
      const { id } = accerroryItem.dataset

      const freeCount = this.#freeMap[id] || 0

      window.publish('bus:accessory_picker_quantity_changed')
      const quantity = +target.value + freeCount
      window.publish('bus:accessory_picker_changed', { id, checked: true, quantity })
    }

    handleMoreChange = () => {
      if (!this.moreInput) return
      this.classList.toggle('show-more', this.moreInput.checked)
    }

    handleFreeAccessory = () => {
      this.quantityInputs.forEach(quantityInput => {
        const freeCount = +quantityInput.dataset.freeCount
        if (freeCount <= 0) return

        quantityInput.value = freeCount

        const accerroryItem = this.#quantityToAccessoryItem.get(quantityInput)
        if (!accerroryItem) return

        const { pickerCheckbox } = this.#accessoryItemToInput.get(accerroryItem)
        pickerCheckbox.checked = true
        pickerCheckbox.onclick = evt => evt.preventDefault()
        const id = accerroryItem.dataset.id
        window.publish('bus:accessory_picker_changed', { id, checked: true, quantity: freeCount })
        this.#freeMap[id] = freeCount
      })
    }

    handleShowroom = () => {
      this.showroomAccessoryItems.forEach(showroomAccessoryItem => {
        const quantity = +showroomAccessoryItem.dataset.showroomSelectedQuantity
        const { pickerCheckbox, quantityInput } = this.#accessoryItemToInput.get(showroomAccessoryItem)

        pickerCheckbox.checked = true
        pickerCheckbox.dispatchEvent(new Event('change', { bubbles: true }))

        if (+quantityInput.value !== quantity) {
          quantityInput.value = quantity
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }))
        }
      })
    }

    _onVariantChange = ({ variantId }) => {
      const accessories = this._variantConfigs[variantId]
      if (!accessories || !accessories.length) return

      this.removeEvents()

      const visibleCount = Number(this.dataset.visibleCount)

      this.render(accessories, visibleCount)

      this.init()
    }

    render = (accessories, visibleCount) => {
      let html = `
      <div class="ly-main-product-form-accessory-picker-list default">
      </div>
      `

      if (accessories.length > visibleCount) {
        html += `
        <div class="ly-main-product-form-accessory-picker-list-more-wrapper ly-expandable-grid">
          <div class="ly-main-product-form-accessory-picker-list-more-inner-wrapper ly-expandable-grid-inner">
            <div class="ly-main-product-form-accessory-picker-list more">
            </div>
          </div>
        </div>
                
        <label class="ly-main-product-form-accessory-picker-list-more-trigger">
          <span class="show-text">${this.dataset.showText}</span>
          <span class="hide-text">${this.dataset.hideText}</span>
          <span class="svg-wrapper">
            <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
              <path d="M512.711 703.143l383.252-383.252c17.574-17.573 46.066-17.573 63.64 0 17.573 17.574 17.573 46.067 0 63.64L512.71 830.423 65.82 383.53c-17.574-17.573-17.574-46.066 0-63.64 17.573-17.573 46.066-17.573 63.64 0L512.71 703.143z"></path>
            </svg>
          </span>
          <input type="checkbox" class="ly-hide ly-main-product-form-accessory-picker-list-more-trigger-input">
        </label>
        `
      }

      this.jsRenderWrapper.innerHTML = html

      const defaultWrapper = this.jsRenderWrapper.querySelector('.ly-main-product-form-accessory-picker-list.default')
      const moreWrapper = this.jsRenderWrapper.querySelector('.ly-main-product-form-accessory-picker-list.more')

      defaultWrapper.innerHTML = accessories.slice(0, visibleCount).map(this.renderItem).join('')

      if (moreWrapper) {
        moreWrapper.innerHTML = accessories.slice(visibleCount).map(this.renderItem).join('')
      }
    }

    renderItem = (accessory) => {
      const tag = (accessory.freeCount > 0 || accessory.comming) ? 'div' : 'label'

      const currentPrice = this.formatter.format(accessory.variant.currentPrice / 100)
      const originalPrice = accessory.variant.originalPrice > accessory.variant.currentPrice ? this.formatter.format(accessory.variant.originalPrice / 100) : ''

      const image = accessory.variant.productImage

      const src = `${image}&width=60`
      const srcset = [60, 86, 120, 172, 180].map(width => `${image}&width=${width} ${width}w`).join(',')

      let freeTagHtml = ''
      if (accessory.freeCount > 0) {
        freeTagHtml = `
        <div class="ly-main-product-form-accessory-picker-item-info-free-tag">${this.dataset.freeText}</div>
        `
      } else if (accessory.tag) {
        freeTagHtml = `
        <div class="ly-main-product-form-accessory-picker-item-info-free-tag">${accessory.tag}</div>
        `
      }

      let freeCountHtml = ''
      let moreLinkHtml = ''
      if (accessory.freeCount > 0) {
        freeCountHtml = `<div class="ly-main-product-form-accessory-picker-item-info-free-count">x${accessory.freeCount}</div>`
      } else {
        moreLinkHtml = `
        <label class="ly-main-product-form-accessory-picker-item-info-more-link" for="${accessory.popoverId}">
          ${this.dataset.moreLinkTitle}
        </label>
        `
      }

      const popoverHtml = this.renderItemPopover(accessory)

      const extraClasses = []
      if (accessory.freeCount > 0) {
        extraClasses.push('is-free')
      }
      if (accessory.comming) {
        extraClasses.push('is-comming')
      }
      return `
      <${tag} class="ly-main-product-form-accessory-picker-item ${extraClasses.join(' ')}" data-id="${accessory.variant.id}">
          <div class="ly-main-product-form-accessory-picker-item-wrapper">
            <input
              class="ly-checkbox ly-main-product-form-accessory-picker-item-picker-checkbox"
              type="checkbox"
              data-original-price="${accessory.variant.originalPrice}"
              data-current-price="${accessory.variant.currentPrice}"
              data-variant-id="${accessory.variant.id}"
              data-installation-service-price="${accessory.variant.installationService.currentPrice}"
              data-installation-service-original-price="${accessory.variant.installationService.originalPrice}"
              data-installation-service-variant-id="${accessory.variant.installationService.id}"
              ${accessory.disabledForCart ? 'data-disabled-for-cart' : ''}
              ${accessory.comming ? 'disabled' : ''}
            >

            ${this.createOrderSummarySkuConfigHtml(accessory.variant)}
                      
            <div class="ly-main-product-form-accessory-picker-item-image">
              <img src="${src}" srcset="${srcset}" sizes="(max-width: 767px) 60px, 86px" width="86" height="70" loading="lazy">
            </div>    
                      
            <div class="ly-main-product-form-accessory-picker-item-info">
              <div class="ly-main-product-form-accessory-picker-item-info-top">
                <div class="ly-main-product-form-accessory-picker-item-info-title">
                  ${accessory.variant.productTitle}
                </div>
                ${freeTagHtml}
              </div>
              <div class="ly-main-product-form-accessory-picker-item-info-bottom">
                <div class="ly-main-product-form-accessory-picker-item-info-price-wrapper">
                  <div class="ly-main-product-form-accessory-picker-item-info-current-price">
                    ${accessory.freeCount > 0 ? this.formatter.format(0) : currentPrice}
                  </div>
                  <s class="ly-main-product-form-accessory-picker-item-info-original-price">
                    ${accessory.freeCount > 0 ? currentPrice : originalPrice}
                  </s>
                </div>
                
                ${freeCountHtml}
                ${moreLinkHtml}
              </div>
            </div>
          </div>
          <div class="ly-main-product-form-accessory-picker-item-quantity-wrapper ly-expandable-grid">
            <div class="ly-main-product-form-accessory-picker-item-quantity-inner-wrapper ly-expandable-grid-inner">
              <div class="ly-main-product-form-accessory-picker-item-quantity">
                <div class="ly-main-product-form-accessory-picker-item-quantity-inner">
                  <div class="ly-p">Quality:</div>
                  <ly-quantity-input>
                    <button name="minus" type="button" disabled>
                      <span class="svg-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"/></svg>
                      </span>
                    </button>
                    <input
                      class="ly-main-product-form-accessory-picker-item-quantity-input"
                      type="number"
                      value="1"
                      min="${accessory.variant.min}"
                      ${accessory.variant.max ? `max="${accessory.variant.max}"` : ''}
                      step="${accessory.variant.step}"
                      data-free-count="${accessory.freeCount}"
                    >
                    <button name="plus" type="button">
                      <span class="svg-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>
                      </span>
                    </button>
                  </ly-quantity-input>
                </div>
              </div>
            </div>
          </div>
          ${popoverHtml}
      </${tag}>
      `
    }

    renderItemPopover = (accessory) => {
      if (accessory.freeCount > 0) return ''

      let mediaHtml = ''
      const medias = accessory.variant.popoverMedias
      if (medias && medias.length) {

        const mediasHtml = medias.map(media => {
          const src = `${media}&width=390`
          const srcset = [390, 705, 780, 1410, 1170].map(w => `${media}&width=${w} ${w}w`).join(',')
          return `
          <div class="ly-main-product-form-accessory-picker-item-popover-media ly-main-product-form-list-picker-popover-media" data-scroller-item>
            <img src="${src}" srcset="${srcset}" sizes="(max-width: 767px) 390px, 705px" width="705" height="400" loading="lazy" draggable="false">
          </div>
          `
        }).join('')

        const indicatorsHtml = renderIndicatorItems(medias)

        mediaHtml = `
        <ly-full-scroll-carousel>
          <div class="ly-main-product-form-accessory-picker-item-popover-medias ly-main-product-form-list-picker-popover-medias" data-scroller>
            ${mediasHtml}
          </div>
          ${indicatorsHtml}
          
          ${renderLyCtrlButtons(2)}
        </ly-full-scroll-carousel>
        `
      }

      const html = `
      <div class="ly-main-product-form-accessory-picker-item-popover-wrapper ly-main-product-form-list-picker-popover-wrapper">
        <div class="ly-main-product-form-accessory-picker-item-popover-inner-wrapper ly-main-product-form-list-picker-popover-inner-wrapper">
          ${mediaHtml}
          <div class="ly-main-product-form-accessory-picker-item-popover-content ly-main-product-form-list-picker-popover-content ly-p">
            ${accessory.variant.popoverContent}
          </div>
        </div>
      </div>
      `

      return renderLyPopoverV4(
        accessory.popoverId,
        accessory.variant.productTitle,
        html)
    }
  })
}